import React from 'react';
import { cx } from './utils';

export default function Card({ className, as: Comp = 'div', ...props }) {
  return <Comp className={cx('card', className)} {...props} />;
}
